/* eslint-disable func-style */
import { BreakPointCondition, useBreakpointIf } from '@genial/components';
import { Utils } from '@genial/utils';
import React from 'react';

export function useDeviceType() {
  const [deviceType, setDeviceType] = React.useState('');

  const isMobile = useBreakpointIf(BreakPointCondition.EqualOrDown, 'sm');
  const isTablet = useBreakpointIf(BreakPointCondition.EqualOrDown, 'lg');

  React.useEffect(() => {
    if (isMobile) {
      setDeviceType('mobile');
    } else if (isTablet) {
      setDeviceType('tablet');
    } else {
      setDeviceType('desktop');
    }
  }, [isMobile, isTablet]);

  return deviceType;
}

export interface ICustomer {
  name: string;
  email: string;
  document: string;
  sinacorAccount: string;
  monthCompetence: string;
  balanceAvailable: string;
  rate: string;
}

export const customersData: ICustomer[] = [
  {
    name: 'Johanna Silva',
    email: 'johanna.silva@br.com',
    balanceAvailable: '5000.00',
    document: '123456789',
    sinacorAccount: '123456',
    monthCompetence: 'Outubro',
    rate: '10.00',
  },
  {
    name: 'Johanna Silva',
    email: 'johanna.silva@br.com',
    balanceAvailable: '5000.00',
    document: '123456789',
    sinacorAccount: '123456',
    monthCompetence: 'Outubro',
    rate: '10.00',
  },
  {
    name: 'Johanna Silva',
    email: 'johanna.silva@br.com',
    balanceAvailable: '5000.00',
    document: '123456789',
    sinacorAccount: '123456',
    monthCompetence: 'Outubro',
    rate: '10.00',
  },
  {
    name: 'Johanna Silva',
    email: 'johanna.silva@br.com',
    balanceAvailable: '5000.00',
    document: '123456789',
    sinacorAccount: '123456',
    monthCompetence: 'Outubro',
    rate: '10.00',
  },
  {
    name: 'Johanna Silva',
    email: 'johanna.silva@br.com',
    balanceAvailable: '5000.00',
    document: '123456789',
    sinacorAccount: '123456',
    monthCompetence: 'Outubro',
    rate: '10.00',
  },
  {
    name: 'Johanna Silva',
    email: 'johanna.silva@br.com',
    balanceAvailable: '5000.00',
    document: '123456789',
    sinacorAccount: '123456',
    monthCompetence: 'Outubro',
    rate: '10.00',
  },
  {
    name: 'Johanna Silva',
    email: 'johanna.silva@br.com',
    balanceAvailable: '5000.00',
    document: '123456789',
    sinacorAccount: '123456',
    monthCompetence: 'Outubro',
    rate: '10.00',
  },
  {
    name: 'Johanna Silva',
    email: 'johanna.silva@br.com',
    balanceAvailable: '5000.00',
    document: '123456789',
    sinacorAccount: '123456',
    monthCompetence: 'Outubro',
    rate: '10.00',
  },
  {
    name: 'Johanna Silva',
    email: 'johanna.silva@br.com',
    balanceAvailable: '5000.00',
    document: '123456789',
    sinacorAccount: '123456',
    monthCompetence: 'Outubro',
    rate: '10.00',
  },
  {
    name: 'Last',
    email: 'last.silva@br.com',
    balanceAvailable: '5000.00',
    document: '123456789',
    sinacorAccount: '123456',
    monthCompetence: 'Outubro',
    rate: '10.00',
  },
];

export const customersDataFailed: ICustomer[] = [
  {
    name: 'Johanna Silva',
    email: 'johanna.silva@br.com',
    balanceAvailable: '5000.00',
    document: '123456789',
    sinacorAccount: '123456',
    monthCompetence: 'Outubro',
    rate: '10.00',
  },
  {
    name: 'Johanna Silva',
    email: 'johanna.silva@br.com',
    balanceAvailable: '5000.00',
    document: '123456789',
    sinacorAccount: '123456',
    monthCompetence: 'Outubro',
    rate: '10.00',
  },
  {
    name: 'Last',
    email: 'last.silva@br.com',
    balanceAvailable: '5000.00',
    document: '123456789',
    sinacorAccount: '123456',
    monthCompetence: 'Outubro',
    rate: '10.00',
  },
];

export type IRequestDetailsData = {
  sendId: string;
  monthCompetence: string;
  type: string;
  billedCustomers: number;
  validatedCustomers: number;
  invalidCustomers: number;
  sendDate: string;
  totalReceivable: string;
  timeAndDateSend: string;
  status: string;
  totalCustomers: number;
  lastUpdate: string;
  requiresAttention: ICustomer[];
  validated: ICustomer[];
};

export const requestDetailsData: IRequestDetailsData = {
  sendId: 'ADF4-170723',
  monthCompetence: 'SETEMBRO',
  type: 'DÉBITO',
  billedCustomers: 50,
  validatedCustomers: 48,
  invalidCustomers: 2,
  sendDate: '01/11/2023',
  totalReceivable: '5000.00',
  timeAndDateSend: '10:00:00 - 01/11/2023 ',
  status: 'ENVIADA',
  // status: 'CANCELADA',
  totalCustomers: customersData.length + customersDataFailed.length,
  lastUpdate: Utils.Mask.DateFormat(new Date(), 'HH:mm:ss dd/MM/yyyy'),
  requiresAttention: customersDataFailed,
  validated: customersData,
};
